var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!../../node_modules/string-replace-webpack-plugin/loader.js?id=mj8nq3d7c3!../../node_modules/string-replace-webpack-plugin/loader.js?id=pgjqzajuokf!./YoutubeVideo.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-cdaf80e6\",\"hasScoped\":false}!../../node_modules/vue-loader/lib/selector?type=template&index=0!../../node_modules/string-replace-webpack-plugin/loader.js?id=mj8nq3d7c3!../../node_modules/string-replace-webpack-plugin/loader.js?id=pgjqzajuokf!./YoutubeVideo.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/YoutubeVideo.vue
// module id = 249
// module chunks = 0